import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { eForceUpdate } from 'src/constrains/SalesChannelMultiLanguageSelect';

//import { instanceType, AllTypes } from 'src/tools/helper';
const switchUuidHooks = ({ uuid }) => {
  const _h = useHistory();
  const _params: any = useParams();
  const {
    uuid: sUuid,
    discountUuid, //==new
  } = _params;

  useAfterDidMountEffect(() => {
    if (uuid !== discountUuid && uuid) {
      _h.push({
        pathname: `/salesChannel/discounts/subscriptionBuy/editor/${sUuid}/${uuid}`,
        state: {
          skipNotice: true,
        },
      });
      // console.log('uuid switch');
      //   eForceUpdate(uuid);
      eForceUpdate(uuid);
    }
  }, [uuid]);
};
export { switchUuidHooks };
